export enum BaseLocationTerminalStatusEnum {
  pending = 'pending',
  offline = 'offline',
  online = 'online',
}
